import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

export function useFeatureFlags() {
    const page = usePage();

    const features = computed(() => {
        return page.props.userData?.features || {};
    });

    /**
     * Check if a feature flag is active
     * @param {string} featureName - The name of the feature flag to check
     * @returns {boolean} - True if the feature is active, false otherwise
     * Note: Uses strict equality (=== true) to ensure only explicitly enabled features return true
     */
    const isFeatureActive = (featureName) => {
        return features.value[featureName] === true;
    };

    // Individual feature flag computed properties for convenience
    const toolsHotelsEnabled = computed(() => {
        return features.value.tools_hotels === true;
    });

    const tripswapEnabled = computed(() => {
        return features.value.tripswap === true;
    });

    // Umbrella transfer-partners flag. Gates the transfer-partners guide as well
    // as the redemption-tracker transfer filtering (source dropdown, flexible
    // destination handling).
    const transferPartnersGuideEnabled = computed(() => {
        return features.value['transfer-partners-guide'] === true;
    });

    // Transfer bonus alerts 10xTravel+ promos. Derived server-side as
    // transfer-partners-guide AND transfer-partners-guide-alerts.
    const transferBonusAlertsEnabled = computed(() => {
        return features.value['transfer-bonus-alerts'] === true;
    });

    return {
        features,
        isFeatureActive,
        toolsHotelsEnabled,
        tripswapEnabled,
        transferPartnersGuideEnabled,
        transferBonusAlertsEnabled,
    };
}
